// src/components/enterprise/consoleTabs.js
//
// The executive console's tabs, in one list: the console's own sidebar
// (ConsoleSidebar.jsx) draws them, EnterpriseConsole.jsx routes them, and the
// hub sidebar's single "Workforce Analytics" entry opens the first one. Labels
// with a labelKey read the sport / workplace wording from the copy dictionary.
// A tab with a `feature` is shown only when that flag is on in the org doc's
// `features` (the super-admin Organization editor); an edition's `hiddenTabs`
// drops tabs that make no sense for it. Either way the console opens the
// overview instead. An org's `deferredConsoleTabs` stay listed but on hold.

import { LayoutDashboard, Landmark, Scale, Database, BrainCircuit, Activity, TrendingUp, DollarSign, MessageSquare } from 'lucide-react';

export const CONSOLE_TABS = [
    { id: 'cc-overview',      labelKey: 'navCcOverview',   label: 'Executive Overview',  Icon: LayoutDashboard },
    { id: 'cc-recovery',      label: 'Alberta Recovery Model',                           Icon: Landmark, feature: 'enableRecoveryModel' },
    { id: 'cc-triangulation', label: 'Triangulation',                                    Icon: Scale },
    { id: 'cc-data',          label: 'Data Intake',                                      Icon: Database },
    { id: 'cc-readiness',     labelKey: 'navCcReadiness',  label: 'Readiness & Strain',  Icon: Activity },
    { id: 'cc-predictive',    labelKey: 'navCcPredictive', label: 'STD Claims Forecast', Icon: TrendingUp },
    { id: 'cc-roi',           label: 'Financial Impact',                                 Icon: DollarSign },
    { id: 'cc-feedback',      label: 'Anonymous Pulse',                                  Icon: MessageSquare },
    { id: 'cc-ai',            label: 'AI Intelligence',                                  Icon: BrainCircuit }
];

// The tabs this edition shows for this organization: a public program has no
// leave forecast or ROI, and a feature-flagged tab needs its flag on the org.
export const visibleConsoleTabs = (edition, org) => {
    const hidden = (edition && edition.hiddenTabs) || [];
    const features = (org && org.features) || {};
    return CONSOLE_TABS.filter((t) => !hidden.includes(t.id) && (!t.feature || !!features[t.feature]));
};

// Tabs an organization has put on hold until it has enough of its own data
// (organizations/{id}.deferredConsoleTabs, e.g. ['cc-predictive', 'cc-roi']): the
// leave outlook and the financial model need a baseline before a forecast or a
// dollar figure is honest. They stay in the sidebar with an "after 90 days" tag,
// the overview's card for them shows the same, and opening one shows
// DeferredPanel instead of the edition's modeled example.
export const deferredConsoleTabs = (org) => (org && Array.isArray(org.deferredConsoleTabs) ? org.deferredConsoleTabs : []);
export const isDeferredTab = (org, id) => deferredConsoleTabs(org).includes(id);
export const DEFERRED_TAB_NOTE = 'after 90 days';

export const consoleTabLabel = (tab, t) => (tab.labelKey && typeof t === 'function' ? t(tab.labelKey) : tab.label);

// command-center is the console's front door; every tab id starts with cc-.
export const isConsoleTab = (id) => id === 'command-center' || String(id || '').startsWith('cc-');
